import { render, staticRenderFns } from "./EmbeddedSocialMediaReviewPc.vue?vue&type=template&id=02b2cf4f&scoped=true"
import script from "./EmbeddedSocialMediaReviewPc.vue?vue&type=script&lang=js"
export * from "./EmbeddedSocialMediaReviewPc.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedSocialMediaReviewPc.vue?vue&type=style&index=0&id=02b2cf4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b2cf4f",
  null
  
)

export default component.exports